export default "__VITE_ASSET__DMeOR5eI__"